import { TextField } from '@mui/material'
import { usePersonaStore } from '../../../../../store/usePersonaStore'

const AdditionalInfo = () => {
  const { additionalInfo, setAdditionalInfo } = usePersonaStore()

  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">추가로 참고할 점을 알려주세요.</span>
      <span className="Caption-12Md text-gray-500 mt-[10px]">대화 상대의 사전 정보로 기억됩니다.</span>

      <TextField
        variant="standard"
        placeholder="참고할 점 입력하기"
        value={additionalInfo}
        multiline
        sx={{
          mt: 3,
          '& .MuiInputBase-inputMultiline': {
            outline: 'none !important', // ✅ 진짜로 없애기
          },
          '& .Mui-focused .MuiInputBase-inputMultiline': {
            outline: 'none !important', // ✅ 포커스 중에도 없애기
          },
          '& .MuiInputBase-inputMultiline:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '& .MuiInput-underline:after': {
            borderBottom: '2px solid #503CC8', // ✅ focus 시 밑줄
          },
        }}
        onChange={(e) => setAdditionalInfo(e.target.value)}
      />
    </div>
  )
}

export default AdditionalInfo
